/**
 * Web Audio synthesizer for timer beeps. No file dependencies.
 * Sounds:
 * - tickBeep(): short 880Hz beep for last 3s (3, 2, 1)
 * - endBeep(): longer 440Hz beep for end of segment (0)
 */
let _ctx = null;

const getCtx = () => {
  if (!_ctx) {
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return null;
      _ctx = new AudioCtx();
    } catch {
      return null;
    }
  }
  // Resume if suspended (autoplay policy)
  if (_ctx.state === "suspended") {
    _ctx.resume().catch(() => {});
  }
  return _ctx;
};

const _tone = (frequency, durationMs, volume = 0.3) => {
  const ctx = getCtx();
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.frequency.value = frequency;
  osc.type = "sine";
  gain.gain.setValueAtTime(0, ctx.currentTime);
  gain.gain.linearRampToValueAtTime(volume, ctx.currentTime + 0.01);
  gain.gain.linearRampToValueAtTime(0, ctx.currentTime + durationMs / 1000);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start();
  osc.stop(ctx.currentTime + durationMs / 1000 + 0.05);
};

export const tickBeep = () => _tone(880, 120, 0.25);
export const endBeep = () => _tone(440, 600, 0.4);

// Initialize audio on first user interaction (browsers require user gesture)
export const unlockAudio = () => {
  getCtx();
};
